const priceSortList = {
  default: { label: 'Výchozí' },
  cheapest: { label: 'Nejlevnější' },
  mostExpensive: { label: 'Nejdražší' }
}

const priceValueList = {
  0: { label: 'bez limitu' },
  1000: { label: 'do 1000 Kč' },
  2000: { label: 'do 2000 Kč' },
  3000: { label: 'do 3000 Kč' },
  5000: { label: 'do 5000 Kč' },
  10000: { label: 'do 10000 Kč' }
}

const dateValueList = {
  default: { label: 'Vše' },
  currentMonth: { label: 'Tento měsíc' },
  nextMonth: { label: 'Příští měsíc' }
}

const dateRangeValueList = {
  from: { label: 'Od' },
  to: { label: 'Do' }
}

export { priceSortList, priceValueList, dateValueList, dateRangeValueList }
